export const AUDIO_LOAD_START_EVENT = 'trackAudioLoadStart';
export const AUDIO_LOAD_END_EVENT = 'trackAudioLoadEnd';
export const WORKSPACE_FOCUS_REQUEST_EVENT = 'workspaceFocusRequest';
export const WORKSPACE_TRACK_MENU_REQUEST_EVENT = 'workspaceTrackMenuRequest';
